module.exports = __webpack_public_path__ + "img/visa-ap-gp.e3fafb63.svg";